module.exports = __webpack_public_path__ + "static/media/Instagram.7bbebb72.JPG";